import Pane from 'components/Common/Pane'
import Group from 'components/utils/Group'
import { LOYALTY_OFFERS_HUB_LIMITED_TIME_OFFERS_HASH } from 'loyalty/lib/loyaltyOffersHub/constants'
import type { LoyaltyOffersHubOffer } from 'loyalty/lib/loyaltyOffersHub/types'
import Heading from 'LuxKit/Typography/Heading'
import { useIntl } from 'react-intl'
import LoyaltyOffersHubOfferGrid from './LoyaltyOffersHubOfferGrid'

interface Props {
  offers: Array<LoyaltyOffersHubOffer>
}

function LoyaltyOffersHubLimitedTimeOffersSection({ offers }: Props) {
  const intl = useIntl()

  if (!offers.length) return null

  return <Pane background="none" padding="40 0">
    <Group direction="vertical" gap={24}>
      <Heading id={LOYALTY_OFFERS_HUB_LIMITED_TIME_OFFERS_HASH} variant="heading2">
        {intl.formatMessage({
          id: 'INrAMQE9yL5OB-JKGlCT',
          defaultMessage: 'Limited time offers',
          description: 'Heading for limited-time offers section on the Societe offers hub page',
        })}
      </Heading>
      <LoyaltyOffersHubOfferGrid offers={offers} />
    </Group>
  </Pane>
}

export default LoyaltyOffersHubLimitedTimeOffersSection
